(() => {
  const CRYSTAL_PRICING_EVENTS = {
    proof_selected: 'crystal_proof_selected',
    size_selected: 'crystal_configuration_changed',
  };
  const MAX_STRING_LENGTH = 120;
  const pendingEvents = [];

  function cleanValue(value) {
    if (typeof value === 'string') {
      return value.trim().slice(0, MAX_STRING_LENGTH);
    }
    if (typeof value === 'number' || typeof value === 'boolean') {
      return value;
    }
    return undefined;
  }

  function cleanPayload(payload) {
    return Object.entries(payload || {}).reduce((result, [key, value]) => {
      const clean = cleanValue(value);
      if (clean !== undefined) {
        result[key] = clean;
      }
      return result;
    }, {});
  }

  function getPageContext() {
    const productInfo = document.querySelector('product-info');
    const pathParts = window.location.pathname.split('/').filter(Boolean);
    const productHandle = productInfo?.dataset.productHandle
      || (pathParts[0] === 'products' ? pathParts[1] : '');

    return cleanPayload({
      page_path: window.location.pathname,
      page_type: Array.from(document.body.classList).find((name) => name.startsWith('template-')) || '',
      product_id: productInfo?.dataset.productId || '',
      product_handle: productHandle || '',
      product_title: productInfo?.dataset.productTitle || '',
    });
  }

  function deliver(entry) {
    if (entry.delivered) return true;

    try {
      if (typeof window.Shopify?.analytics?.publish === 'function') {
        const crystalPricingEvent = CRYSTAL_PRICING_EVENTS[entry.name];
        if (crystalPricingEvent) {
          window.Shopify.analytics.publish(crystalPricingEvent, entry.payload);
          entry.delivered = 'crystal_pricing';
        } else {
          // Keep unsupported behavioral events available to theme code without
          // forwarding them through a separate, session-creating GA4 pixel.
          entry.delivered = 'local_only';
        }
        return true;
      }

      entry.delivered = 'local_only';
      return true;
    } catch (error) {
      console.warn('CCM analytics event delivery failed', error);
    }

    return false;
  }

  function track(name, payload = {}) {
    if (!name) return;

    const entry = {
      name,
      payload: cleanPayload({
        ...getPageContext(),
        ...payload,
        analytics_version: '1',
      }),
      delivered: false,
    };

    pendingEvents.push(entry);
    window.ccmAnalyticsQueue = window.ccmAnalyticsQueue || [];
    window.ccmAnalyticsQueue.push(entry);

    document.dispatchEvent(new CustomEvent('ccm:analytics', {
      detail: {
        name: entry.name,
        payload: entry.payload,
      },
    }));

    deliver(entry);
  }

  function flushPendingEvents() {
    pendingEvents.forEach(deliver);
  }

  window.ccmAnalytics = {
    track,
    flush: flushPendingEvents,
    version: '1',
  };

  const flushTimer = window.setInterval(() => {
    flushPendingEvents();
    if (pendingEvents.length > 0 && pendingEvents.every((entry) => entry.delivered)) {
      window.clearInterval(flushTimer);
    }
  }, 1000);
  window.setTimeout(() => window.clearInterval(flushTimer), 15000);

  document.addEventListener('change', (event) => {
    if (!event.isTrusted || !(event.target instanceof HTMLInputElement)) return;

    const input = event.target;
    if (input.matches('[data-proof-preview-toggle]')) {
      track('proof_selected', {
        selected: input.checked,
        proof_type: 'designer_proof',
      });
      return;
    }

    if (input.matches('.size-row input[type="radio"][form]')) {
      track('size_selected', {
        size: input.value,
        option_name: input.name,
      });
    }
  });

  document.addEventListener('click', (event) => {
    if (!event.isTrusted || !(event.target instanceof Element)) return;

    const checkoutButton = event.target.closest('[name="checkout"]');
    if (!checkoutButton) return;

    let source = 'unknown';
    if (checkoutButton.closest('#cart-notification')) {
      source = 'cart_popup';
    } else if (checkoutButton.closest('#CartDrawer')) {
      source = 'cart_drawer';
    } else if (document.body.classList.contains('template-cart')) {
      source = 'cart_page';
    }

    track('checkout_click', { source });
  }, true);

  document.addEventListener('DOMContentLoaded', () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.productAdditional) {
      subscribe(PUB_SUB_EVENTS.productAdditional, ({ data }) => {
        if (data?.method !== 'add') return;
        track('accessory_added', {
          accessory_title: data.target?.dataset?.productTitle || data.target?.closest('li')?.querySelector('.product-title')?.textContent || '',
          variant_id: data.target?.dataset?.variantId || '',
          source: 'pdp',
        });
      });
    }

    if ('IntersectionObserver' in window) {
      const viewedAccessoryRows = new WeakSet();
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || viewedAccessoryRows.has(entry.target)) return;
          viewedAccessoryRows.add(entry.target);
          observer.unobserve(entry.target);
          track('accessories_expanded', {
            presentation: 'always_open',
            source: 'pdp',
          });
        });
      }, { threshold: 0.35 });

      document.querySelectorAll('.additional-row').forEach((row) => observer.observe(row));
    }
  });
})();
